const styles = (props) => ({
	modal: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	container: {
		background: props.palette.secondary.darker,
		display: "flex",

		borderRadius: "22px",
		maxWidth: "748px",
		width: "80%",
		maxHeight: "89vh",
		overflow: "auto",
		flexDirection: "column",
		gap: 2,
		padding: 2,
	},

	title: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: props.palette.white.main,
	},
	body: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		width: "100%",
		padding: 2,
		pt: 2,
		borderRadius: "22px",
		background: props.palette.background.modalContrast,
	},
	content: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
		width: "100%",
	},
	form: { display: "flex", flexDirection: "row", gap: "64px" },
	textfield: {
		borderRadius: "8px",
		"& .MuiFilledInput-root": {
			backgroundColor:
				props.palette.mode == "dark"
					? props.palette.secondary.dark
					: props.palette.secondary.light,
			borderRadius: "8px",
			"&:hover": {
				backgroundColor:
					props.palette.mode == "dark"
						? props.palette.secondary.darker
						: props.palette.secondary.dark,
			},
		},
		"& .Mui-disabled": {
			backgroundColor:
				props.palette.mode == "dark"
					? props.palette.secondary.dark
					: props.palette.secondary.light,
			borderRadius: "8px",
		},
		"& .MuiFilledInput-root.Mui-disabled": {
			backgroundColor:
				props.palette.mode == "dark"
					? props.palette.secondary.dark
					: props.palette.secondary.light,
		},
		"& .MuiFilledInput-root:hover": {
			bgcolor:
				props.palette.mode == "dark"
					? props.palette.secondary.darker
					: props.palette.secondary.medium,
		},
		"& .MuiInputLabel-filled": {
			color:
				props.palette.mode == "dark"
					? props.palette.colors.gray.light
					: props.palette.secondary.dark,
			transform: "translate(12px, 8px) scale(1)", // Posição padrão (não focada)
			"&.MuiInputLabel-shrink": {
				transform: "translate(12px, -9px) scale(0.75)", // Posição quando sobe (focada/preenchida)
			},
		},
		"& .MuiFilledInput-input": {
			color:
				props.palette.mode == "dark"
					? props.palette.white.main
					: props.palette.colors.black.dark,
			// Ajustes específicos para o tamanho small
			paddingTop: "6px !important", // Reduz o padding para ficar compacto
			paddingBottom: "10px !important",
			fontSize: "0.875rem !important", // Tamanho de fonte padrão para small
		},
		"& .MuiInputBase-input.Mui-disabled": {
			WebkitTextFillColor:
				props.palette.mode == "dark"
					? props.palette.colors.gray.light
					: props.palette.colors.black.medium,
		},
		"& .MuiInputLabel-filled.Mui-disabled": {
			backgroundColor: "transparent", // remove o fundo
			WebkitBackgroundClip: "text", // garante que só o texto apareça
		},
	},
	asTextField: {
		width: "340px",
		"@media (max-width: 920px)": {
			width: "100%",
		},
		"& .MuiInputLabel-root.Mui-error": {
			color: "secondary.main",
		},
		"& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
			border: "3px solid",
			borderColor: "secondary.main",
		},
		"& .MuiFormHelperText-root.Mui-error": {
			color: "secondary.main",
		},
	},
	stack: {
		width: "100%",
	},
	boxForm: { display: "flex", flexDirection: "column", gap: 1, width: "100%" },
	boxButton: {
		display: "flex",
		justifyContent: "end",
		"@media (max-width: 920px)": { justifyContent: "center" },
	},
	button: {
		borderRadius: "10px",
		mr: 2,
		height: "40px",

		"@media (max-width: 340px)": { width: "100%" },
	},
});

export default styles;
